<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.patients', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<div class="row justify-content-center">
    
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                    <small>{{ $t('message.welcomeToMedicasure') }}</small>
                </div>
                <div class="row justify-content-center">

                    <div class="success">
                        <p>{{ $t('message.PaiementSuccess') }}: </p>
                    </div>

                </div>
                <div class="row justify-content-center">

                    <b-btn variant="primary" :loading="loader" color="primary" @click="omsubmit">
                        {{ $t('message.completeProfile') }}
                    </b-btn>

                </div>
            </div>
        </div>

    </div>
</div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    mapGetters
} from "vuex";
import AppConfig from "../../constants/AppConfig";
export default {
    name: 'landing',

    data() {
        return {
            isLoading: true,
            opacity: 1,
            canCancel: false,
            fullPage: false,
        };
    },
    methods: {

        omsubmit: function () {
            this.$router.push({ name: 'edit-subscriber', params: { subscriber: (JSON.parse(localStorage.getItem('user')))['slug'] } });
        }
    },
}
</script>
<!-- End Facebook Pixel Code -->
<style scoped>

</style>
